import { CSSProperties } from 'react';
import { theme } from '../../theme';
import { isDesktop } from '../../platform';

export const paymentMethodCarouselStyles = {
  container: {
    width: '100%',
  } as CSSProperties,

  contained: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    containerType: 'inline-size',
    paddingBottom: theme.spacing.extraLarge,
  } as CSSProperties,

  scrollContainer: {
    display: 'flex',
    alignItems: 'center',
    overflowX: 'auto',
    gap: theme.spacing.tiny,
    paddingBottom: theme.spacing.tiny,
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
    marginLeft: -theme.spacing.medium,
    marginRight: -theme.spacing.medium,
    scrollBehavior: 'smooth',
    WebkitOverflowScrolling: 'touch',
    scrollSnapType: 'x mandatory',
  } as CSSProperties,

  containedScroll: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    overflowX: 'auto',
    overflowY: 'hidden',
    // El gutter de cada lado centra la tarjeta activa. El gap se come parte
    // de ese gutter, así a la derecha asoma solo una franja de la siguiente.
    gap: theme.spacing.extraSmall,
    paddingBottom: theme.spacing.tiny,
    paddingLeft: theme.spacing.mediumLarge,
    paddingRight: theme.spacing.mediumLarge,
    cursor: 'grab',
    touchAction: 'pan-x',
    overscrollBehaviorX: 'contain',
    WebkitOverflowScrolling: 'touch',
    scrollSnapType: 'x mandatory',
    scrollbarWidth: 'none',
    ...(isDesktop && {height: 188}),
  } as CSSProperties,

  containedItem: {
    flex: `0 0 calc(100cqw - ${theme.spacing.mediumLarge * 2}px)`,
    width: `calc(100cqw - ${theme.spacing.mediumLarge * 2}px)`,
    maxWidth: `calc(100cqw - ${theme.spacing.mediumLarge * 2}px)`,
    minWidth: 0,
    scrollSnapAlign: 'center',
    boxSizing: 'border-box',
  } as CSSProperties,

  carouselItem: {
    flexShrink: 0,
    scrollSnapAlign: 'start',
    minWidth: 'min(calc(100% - 32px), 400px)',
    paddingRight: theme.spacing.tiny,
  } as CSSProperties,

  hint: {
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.palette.grey750,
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    margin: 0,
    marginTop: isDesktop ? theme.spacing.extraLarge : theme.spacing.medium,
  } as CSSProperties,

  arrow: {
    display: 'inline-block',
    height: 16,
    width: 16,
  } as CSSProperties
};
